import { render } from "./BrandPortfolioParentSpendBar.vue?vue&type=template&id=0d792a26&scoped=true"
import script from "./BrandPortfolioParentSpendBar.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioParentSpendBar.vue?vue&type=script&lang=js"

import "./BrandPortfolioParentSpendBar.vue?vue&type=style&index=0&id=0d792a26&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d792a26"]])

export default __exports__